export default __webpack_public_path__ + "static/media/Headshot-6.3ef2b4f6.png";